import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";

/**
 * this component sets a condition and accepts a value for the condition
 * @event setDisplay
 * @property {boolean} conditionMet
 */
@Component({
  selector: "scaffold-conditional",
  templateUrl: "./conditional.component.html",
  styleUrls: ["../../rendered.component.scss", "./conditional.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionalComponent
  extends BaseScaffoldComponent
  implements OnInit {
  // @Output() setDisplay = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  conditionMet = false;
  constructor (
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit () {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });

    //    this.item.conditionalComp = this;

    this.conditionMet = this.checkCondition();
  }

  ngOnDestroy () {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  // setDisplayItem(item) {
  //   this.setDisplay.emit(item);
  // }
  checkCondition () {
    let value = this.value;
    let item = this.item;
    // TODO
    // if (this.data && this.getValue(this.data, item.name)) {
    //     value = this.getValue(this.data,item.name);
    // }
    //console.log(value, item.condition)
    if (
      item.condition &&
      ((value != undefined && item.req_value) ||
        item.condition == "notdefined" ||
        (value !== false && item.condition == "defined") ||
        (value && item.condition == "true") ||
        item.condition == "false")
    ) {
      switch (item.condition) {
        case "equal":
          if (item.req_value.indexOf(",") >= 0) {
            let vals = item.req_value.split(/\s*,\s*/g);
            return (
              vals.indexOf(value.toString()) >= 0 || vals.indexOf(value) >= 0
            );
          } else {
            return value.toString() == item.req_value;
          }

        case "less":
          if (!isNaN(value) && !isNaN(item.req_value))
            return Number(value) < Number(item.req_value);
          else return value < item.req_value;

        case "notdefined":
          return value == null && item.value == null;

        case "defined":
          return value != null || item.value != null;

        case "length":
          const strValue = '' + value;
          if (item.length_comparison === 'less') {
            return strValue.length < Number(item.req_value);
          }
          return strValue.length >= Number(item.req_value);

        case "regex":
          let flags;
          if (!item.req_value || item.req_value.length === 0) {
            return false;
          }
          let pattern = item.req_value;
          if (pattern.indexOf("|") == 0) {
            const split = pattern.split("|");
            flags = split[1];
            pattern = split[0];
          }
          let test = new RegExp(pattern, flags);
          return test.test(value);

        case "greater":
          if (!isNaN(value) && !isNaN(item.req_value))
            return Number(value) > Number(item.req_value);
          else return value > item.req_value;

        case "notequal":
          if (item.req_value.indexOf(",") >= 0) {
            var vals = item.req_value.split(/\s*,\s*/g);
            return (
              vals.indexOf(value.toString()) < 0 && vals.indexOf(value) < 0
            );
          } else {
            return value.toString() != item.req_value;
          }

        case "true":
          if (item.value === true || item.value === "true") {
            return true;
          }
          break;
        case "false":
          if (
            item.value === false ||
            item.value === "false" ||
            item.value === undefined
          ) {
            return true;
          }
          break;
        default:
          return false;
      }
      return false;
    }
  }

  update () {
    // console.log("update conditional")
    this.conditionMet = this.checkCondition();
    this.cdr.markForCheck();
  }
}
